import { type FieldValues, useController } from 'react-hook-form';
import type { CheckboxValue } from '../Checkbox/Checkbox.types';
import {
  CheckboxField,
  type CheckboxFieldProps,
} from '../CheckboxField/CheckboxField';
import type {
  FormControlProps,
  TypedUseControllerProps,
} from '../FormControl/FormControl.types';

export type FormCheckboxProps<TFieldValues extends FieldValues = FieldValues> =
  TypedUseControllerProps<TFieldValues, CheckboxValue> &
    FormControlProps<CheckboxFieldProps>;

/*
 *  FormCheckbox encapsulates the Checkbox component and provides a form control with validation to be used with React Hook Form.
 */
export const FormCheckbox = <TFieldValues extends FieldValues = FieldValues>({
  disabled,
  ...props
}: FormCheckboxProps<TFieldValues>) => {
  const {
    field: { ref, ...field },
    formState: { errors },
  } = useController(props);

  const error = errors[props.name]?.message?.toString();

  return (
    <CheckboxField
      {...props}
      {...field}
      disabled={disabled}
      error={error}
      innerRef={ref}
    />
  );
};
